import gql from 'graphql-tag'

export const GET_FAQ_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getFaqPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        questionEn
        questionKg
        questionRu
        showIn
      }
    }
  }
`

export const GET_FAQ_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getFaq (
      data: {
        id: $id
      }
    ) {
      id
      questionEn
      questionKg
      questionRu
      answerEn
      answerKg
      answerRu
      showIn
      url
    }
  }
`
